<script lang="ts">
	import { load_image_from } from 'src/helpers/interface_helpers';
	import VideoContainer from './VideoContainer.svelte';
	import { format } from 'svelte-i18n';
	import type { VideoContainerState } from '../types/video-container';

	let videoElement: HTMLVideoElement = null;

	export let imagePoster: string = load_image_from('images/device_images/logo_white_S.png');
	export let videoSrc: string = '';
	export let borderRadius: 'small' | 'medium' | 'big' | 'extra-big' = 'extra-big';

	let isZoomed: boolean = false;
	$: videoElement && (videoElement.src = videoSrc);

	function computeVideoState(src: string): VideoContainerState {
		if (src) return null;
		return {
			type: 'error',
			icon: 'fal fa-video',
			heading: $format('video_player_no_video_heading', { default: 'No Video Available' }),
		};
	}
	$: videoState = computeVideoState(videoSrc);
</script>

<VideoContainer bind:isZoomed state={videoState}>
	<video
		poster={imagePoster}
		bind:this={videoElement}
		autoPlay
		playsInline
		muted
		controls={!isZoomed}
		on:error
		class="width-full"
		style="border-radius: var(--radius-{borderRadius}); aspect-ratio: 16 / 9;"
	>
	</video>
</VideoContainer>
